// extracted by mini-css-extract-plugin
export default {"header":"header_header__9VcW0","inner":"header_inner__KdIuv","logo":"header_logo__soZjv","icons":"header_icons__M1XSq","bell":"header_bell__87yzl","profile":"header_profile__xMEvE"};